// Draft translations for the 2026 Lynsis Event & Floral redesign copy.
// Please review the `ch` values below before shipping — they are a first-pass
// translation of the English marketing copy, not yet reviewed by the studio.
export const floral = {
  nav: {
    home: { en: 'Home', ch: '首页' },
    about: { en: 'About', ch: '关于我们' },
    weddings: { en: 'Weddings', ch: '婚礼' },
    portfolio: { en: 'Portfolio', ch: '作品集' },
    services: { en: 'Services', ch: '服务' },
    inquireNow: { en: 'Inquire Now', ch: '立即咨询' },
  },
  hero: {
    eyebrow: { en: 'Lynsis Event & Floral', ch: 'Lynsis Event & Floral' },
    title: { en: 'Wedding Florals Designed for Your Love Story', ch: '为您的爱情故事设计的婚礼花艺' },
    description: {
      en: 'Thoughtfully designed florals for weddings that feel personal, artful, and deeply considered from the first bloom to the final candlelit detail.',
      ch: '用心设计的婚礼花艺，从第一朵花到烛光下的每个细节，都充满个人风格与艺术巧思。',
    },
    viewWork: { en: 'View Our Work', ch: '查看作品' },
    inquireNow: { en: 'Inquire Now', ch: '立即咨询' },
  },
  about: {
    eyebrow: { en: 'The Studio', ch: '关于工作室' },
    title: { en: 'Floral storytelling for celebrations that feel entirely your own.', ch: '用花艺说故事，打造完全属于您的庆典。' },
    body: {
      en: "Lynsis Event & Floral is a boutique design studio creating romantic, intentional flowers for weddings and joyful gatherings. We bring an artist's eye and a calm, collaborative spirit to every celebration.",
      ch: 'Lynsis Event & Floral 是一间精品花艺设计工作室，为婚礼和喜庆聚会打造浪漫且用心的花艺作品。我们以艺术家的眼光和从容合作的态度，用心对待每一场庆典。',
    },
    learnMore: { en: 'Learn More', ch: '了解更多' },
  },
  services: {
    eyebrow: { en: 'Wedding Services', ch: '婚礼服务' },
    title: { en: 'Flowers for every meaningful moment.', ch: '为每个重要时刻献上花艺。' },
    description: {
      en: 'From a hand-tied bouquet to a room transformed with flowers, each design is guided by your celebration and created with care.',
      ch: '从手绑花束到满室花艺布置，每个设计都围绕着您的庆典，用心打造。',
    },
    bouquets: {
      title: { en: 'Bridal Bouquets', ch: '新娘捧花' },
      text: { en: 'Personal florals with movement, texture, and a sense of occasion.', ch: '富有动感与质感的个人花艺，衬托当下的仪式感。' },
    },
    ceremony: {
      title: { en: 'Ceremony Florals', ch: '仪式花艺' },
      text: { en: 'Thoughtful floral settings for the moment you say yes.', ch: '为您说「我愿意」的那一刻，精心布置花艺场景。' },
    },
    reception: {
      title: { en: 'Reception Florals', ch: '婚宴花艺' },
      text: { en: 'Layered tablescapes and gathered details made for lingering.', ch: '层次丰富的桌花布置，让宾客流连忘返。' },
    },
    installations: {
      title: { en: 'Floral Installations', ch: '花艺装置' },
      text: { en: 'Immersive, sculptural flowers that transform a space with ease.', ch: '沉浸式的雕塑花艺装置，轻松转化整个空间。' },
    },
  },
  portfolio: {
    eyebrow: { en: 'Selected Portfolio', ch: '精选作品' },
    title: { en: 'A few moments in bloom.', ch: '几个绽放的瞬间。' },
    exploreMore: { en: 'Explore More Work', ch: '查看更多作品' },
  },
  approach: {
    eyebrow: { en: 'Our Approach', ch: '我们的理念' },
    title: { en: 'A floral world considered from every angle.', ch: '从每个角度用心构思的花艺世界。' },
    bodyOne: {
      en: 'Each wedding begins with listening. We design around your personal style, the character of your venue, the season, and the atmosphere you want your guests to feel the moment they arrive.',
      ch: '每一场婚礼都从聆听开始。我们根据您的个人风格、场地特色、季节，以及您希望宾客一到场就感受到的氛围来设计花艺。',
    },
    bodyTwo: {
      en: 'The result is never one-size-fits-all: it is a carefully layered floral story, composed with beautiful ingredients and an instinct for the unexpected.',
      ch: '成果从不千篇一律：那是一个层次分明的花艺故事，由美丽的花材与意想不到的巧思共同谱写而成。',
    },
  },
  pricing: {
    title: { en: 'Wedding Floral Collections', ch: '婚礼花艺系列' },
    description: {
      en: 'Every celebration is unique. These starting points offer a gentle guide before we shape a floral proposal around your day.',
      ch: '每场庆典都是独一无二的。以下方案仅供参考，我们会依照您的婚礼量身打造花艺提案。',
    },
    startingFrom: { en: 'Starting From', ch: '起价' },
    requestQuote: { en: 'Request a Custom Quote', ch: '索取专属报价' },
    intimate: {
      title: { en: 'The Intimate', ch: '温馨方案' },
      price: { en: '$1,299', ch: '$1,299' },
      text: {
        en: 'Personal flowers and purposeful ceremony details for smaller gatherings. \n\nIncludes\n\nBridal Bouquet\nGroom’s Boutonniere\nFloral Backdrop\nSigning Table Florals\nWelcome Sign Florals\n\nInquire About Your Wedding',
        ch: '为小型聚会打造的个人花艺与精致仪式细节。\n\n包含项目\n\n新娘捧花\n新郎胸花\n花艺背板\n签名桌花艺\n迎宾牌花艺\n\n立即咨询您的婚礼',
      },
    },
    signature: {
      title: { en: 'The Signature', ch: '招牌方案' },
      price: { en: '$2,680', ch: '$2,680' },
      text: {
        en: 'A complete floral vision for ceremony, cocktail hour, and reception.\n\nIncludes\n\nBridal Bouquet\nGroom’s Boutonniere\nFloral Backdrop\nSigning Table Florals\nAisle Florals × 6\nWelcome Sign Florals\nReception Centerpieces × 6\n\nAisle florals are thoughtfully repurposed as reception centerpieces.',
        ch: '涵盖仪式、鸡尾酒时段与婚宴的完整花艺规划。\n\n包含项目\n\n新娘捧花\n新郎胸花\n花艺背板\n签名桌花艺\n走道花艺 × 6\n迎宾牌花艺\n婚宴桌花 × 6\n\n走道花艺将巧妙转化为婚宴桌花，再次利用。',
      },
    },
    editorial: {
      title: { en: 'The Editorial', ch: '奢华方案' },
      price: { en: 'Custom Pricing', ch: '客制报价' },
      text: {
        en: 'A full-scale, immersive floral direction with artful installations.\n\nIncludes\n\nFull Wedding Floral Design\nCeremony Florals\nReception Florals\nPersonal Flowers\nFloral Installations\nDelivery & Setup',
        ch: '大型沉浸式花艺规划，搭配艺术装置。\n\n包含项目\n\n完整婚礼花艺设计\n仪式花艺\n婚宴花艺\n个人花艺\n花艺装置\n运送与布置',
      },
    },
  },
  testimonials: {
    eyebrow: { en: 'Kind Words', ch: '真挚回馈' },
    title: { en: 'Loved deeply, remembered beautifully.', ch: '深深被爱，美丽长存于记忆中。' },
    one: {
      quote: {
        en: 'Every arrangement felt like a small work of art. Our day felt completely like us.',
        ch: '每一件作品都像一件小小的艺术品，我们的婚礼完全展现了我们自己的风格。',
      },
      name: { en: 'Clara & James', ch: 'Clara & James' },
    },
    two: {
      quote: {
        en: 'The flowers were romantic without ever feeling overdone. Pure magic from beginning to end.',
        ch: '花艺浪漫而不过度，从头到尾都充满魔力。',
      },
      name: { en: 'Elena & Martin', ch: 'Elena & Martin' },
    },
    three: {
      quote: {
        en: 'Lynsis understood our vision immediately and made our venue feel wonderfully alive.',
        ch: 'Lynsis 立刻理解了我们的想法，让场地充满了生命力。',
      },
      name: { en: 'Nora & Theo', ch: 'Nora & Theo' },
    },
  },
  inquiry: {
    eyebrow: { en: 'Wedding Inquiry', ch: '婚礼咨询' },
    title: { en: "Let's create something beautiful.", ch: '一起打造美好的花艺作品。' },
    description: {
      en: "Tell us a little about your celebration. We'll be in touch soon to learn more about your day and share the next steps.",
      ch: '告诉我们一些关于您庆典的资讯，我们将尽快与您联系，进一步了解您的婚礼并分享后续步骤。',
    },
    name: { en: 'Name *', ch: '姓名 *' },
    email: { en: 'Email *', ch: '电子邮件 *' },
    phone: { en: 'Phone Number *', ch: '电话号码 *' },
    weddingDate: { en: 'Wedding Date *', ch: '婚礼日期 *' },
    venue: { en: 'Venue *', ch: '场地 *' },
    guestCount: { en: 'Guest Count *', ch: '宾客人数 *' },
    floralBudget: { en: 'Floral Budget *', ch: '花艺预算 *' },
    floralBudgetPlaceholder: { en: 'Select a budget range', ch: '请选择预算范围' },
    floralBudgetOptions: [
      { en: 'Under $3,000', ch: '$3,000 以下' },
      { en: '$3,000–$6,000', ch: '$3,000–$6,000' },
      { en: '$6,000–$10,000', ch: '$6,000–$10,000' },
      { en: '$10,000+', ch: '$10,000 以上' },
    ],
    servicesNeeded: { en: 'Services Needed *', ch: '所需服务 *' },
    message: { en: 'Tell Us About Your Celebration *', ch: '请告诉我们您的庆典详情 *' },
    submit: { en: 'Send Inquiry', ch: '送出咨询' },
    sending: { en: 'Sending…', ch: '传送中…' },
    validationError: { en: 'Please complete the required fields before sending your inquiry.', ch: '请先填写所有必填栏位再送出咨询。' },
    successTitle: { en: 'Thank You', ch: '感谢您' },
    successMessage: {
      en: "Your inquiry has been received. We'll contact you shortly to begin the conversation.",
      ch: '您的咨询已收到，我们将尽快与您联系。',
    },
    errorMessage: {
      en: 'Your inquiry could not be sent just yet. Please review your details and try again.',
      ch: '您的咨询暂时无法送出，请确认资料后再试一次。',
    },
    close: { en: 'Close', ch: '关闭' },
  },
  footer: {
    tagline: {
      en: 'Thoughtful wedding flowers, gathered with feeling and designed to linger in memory.',
      ch: '用心设计的婚礼花艺，饱含情感，让美好长留记忆中。',
    },
    beginInquiry: { en: 'Begin Your Inquiry', ch: '开始咨询' },
    connect: { en: 'Connect', ch: '联络方式' },
    instagram: { en: 'Instagram', ch: 'Instagram' },
    wechat: { en: 'WeChat', ch: '微信' },
    xiaohongshu: { en: 'Xiaohongshu', ch: '小红书' },
    serviceAreaHeading: { en: 'Service Area', ch: '服务地区' },
    serviceAreaText: {
      en: 'Vancouver, the Fraser Valley, and destination celebrations throughout British Columbia.',
      ch: '温哥华、菲莎河谷，以及卑诗省各地的异地婚礼。',
    },
    copyright: { en: '© 2026 Lynsis Event & Floral. All rights reserved.', ch: '© 2026 Lynsis Event & Floral. 版权所有。' },
  },
};
